import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { FormHelperText } from '@material-ui/core';
import CustomButton from '../customButton';
import AlertDialog from '../alertDialog';
import { isObject, replaceObjectInList } from '../../../utility/helpers';
import DocumentTypeField from './documentTypeField';
import { isEmpty } from '../../../utility/validation';

const DocumentTypeFields = ({
  values = [],
  translations,
  initialValues,
  error = null,
  fieldTypes,
  isDisabled = false,
  onChange,
}) => {
  const [documentIndex, setDocumentIndex] = useState(null);
  const isDeleteDialogOpened = documentIndex !== null;

  const hasError = isEmpty(translations.validationMessages?.[error]);
  const handleAddField = useCallback(() => {
    return onChange([...values, { ...initialValues }]);
  }, [values, initialValues, onChange]);

  const handleOpenDeleteDialog = useCallback(
    fieldIndex => () => {
      setDocumentIndex(fieldIndex);
    },
    []
  );

  const handleCloseDeleteDialog = useCallback(() => {
    setDocumentIndex(null);
  }, []);

  const handleConfirmDelete = useCallback(() => {
    if (documentIndex === null) {
      return;
    }
    const updatedValues = values.filter(
      (val, index) => index !== documentIndex
    );

    onChange(updatedValues);
    setDocumentIndex(null);
  }, [values, onChange, documentIndex]);

  const handleChangeValue = useCallback(
    (field, fieldIndex) => {
      onChange(replaceObjectInList(values, fieldIndex, field));
    },
    [values, onChange]
  );

  return (
    <div>
      {values.map((val, index) => (
        <DocumentTypeField
          key={`document_type_item_${index}`}
          id={index}
          translations={translations.field}
          fieldTypes={fieldTypes}
          value={val}
          error={isObject(error) ? error?.[index] : error}
          isDisabled={isDisabled}
          onDelete={handleOpenDeleteDialog(index)}
          onChange={handleChangeValue}
        />
      ))}
      <CustomButton
        disabled={isDisabled}
        type="addDarkRoundedOutlined"
        onClick={handleAddField}
      >
        {translations.addFieldButton}
      </CustomButton>
      {hasError && (
        <FormHelperText error={hasError}>
          {translations.validationMessages?.[error]}
        </FormHelperText>
      )}
      <AlertDialog
        isOpened={isDeleteDialogOpened}
        translations={translations.deleteDocumentDialog}
        onClose={handleCloseDeleteDialog}
        onConfirm={handleConfirmDelete}
        isWarning
      />
    </div>
  );
};

DocumentTypeFields.propTypes = {
  translations: PropTypes.object.isRequired,
  values: PropTypes.arrayOf(PropTypes.object),
  fieldTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  initialValues: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func.isRequired,
};

export default DocumentTypeFields;
